import React from "react";
import { Stack, Box, Typography } from "@mui/material";
import LoginDetails from "../../components/auth/LoginDetails";
import { useTheme } from "@mui/material/styles";

const Login: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: theme.palette.common.white,
        paddingTop: 3
      }}
    >
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{ margin: 3, gap: 4 }}
      >
        <Box sx={{ width: "100%" }}>
          <Typography color="primary" variant="h2"
            sx={{
              fontWeight: 700,
              fontFamily: "DM Sans",              
              letterSpacing: '-0.23999999463558197px',
            }}
          >
            Welcome back
          </Typography>
          <Typography variant="h5" sx={{ color: theme.palette.text.primary }}>
            Enter your details below to login{" "}
          </Typography>
        </Box>
        <LoginDetails />
      </Stack>
    </Box>
  );
};

export default Login;
